import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "CaretLeft1"
});
const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M30 7.7173C30 5.00681 28.2095 4.18726 26.006 5.88289L11.6535 16.9269C9.44769 18.6243 9.44995 21.378 11.6535 23.0737L26.006 34.1177C28.2118 35.8151 30 34.9881 30 32.2833V7.7173Z",
  fill: "black"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var caretLeft1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { caretLeft1 as default };
